// Check if dom is ready and loaded before running the script
$(document).ready(function () {
    setTimeout(() => {
        // Checks if featured_images is not defined and it is not empty and if we're on laptop or up
        if (
            typeof featured_images !== "undefined" &&
            featured_images.length > 0 &&
        $(window).width() >= 1024
        ) {
            // Selects all products on the collection page "nyheder/news"
            let numberOfproducts = $(".boost-pfs-filter-product-item").length;
            let counter = 0;
            $(".boost-pfs-filter-product-item").each(function (index, element) {
                counter++;

                let isFirstItem = index === 0;
                // If we have more products than featured images, we stop
                if (counter > featured_images.length) {
                return false;
                }
                // Get all classes on the element and remove product-specific class
                const classList = $(this)
                .attr("class")
                .split(/\s+/)
                .filter(function (item) {
                    return item.indexOf("boost-pfs-filter-product-item") === -1;
                });

                const currentFeaturedImage = featured_images[index];
                const imageUrl = currentFeaturedImage["image"];
                const imageLink = currentFeaturedImage["link"];

                let imageBanner = "";
                let attributes = "";

                if (!isFirstItem) {
                    attributes = 'loading="lazy"';
                }

                if (imageLink === "") {
                // Create the banner elements
                imageBanner = $(`
                            <div class="boost-pfs-custom__image-banner ${classList}">
                                <img ${attributes} src="${imageUrl}" />
                            </div>
                        `);
                } else {
                imageBanner = $(`
                            <div class="boost-pfs-custom__image-banner ${classList}">
                                <a href="${imageLink}">
                                    <img ${attributes} src="${imageUrl}" />
                                </a>
                            </div>
                        `);
                }

                const bannerIndexes = new Set();
                for (let i = 0; i < numberOfproducts; i++) {
                if (i === 0 || (i % 6 === 0 && i < numberOfproducts - 1)) {
                    bannerIndexes.add(i + 6);
                }
                }
                if (isFirstItem) {
                $(this).before(imageBanner);
                } else if (bannerIndexes.has(index)) {
                if (featured_images.length > 2) {
                    $(this).before(imageBanner, imageBanner);
                } else {
                    $(this).before(imageBanner);
                }
                }
            });
        }
        // setTimeout(() => {
            // Update the banner image max-height on resize to match product image height
            $(".boost-pfs-custom__image-banner").each(function () {
                let productImageHeight = $($(".boost-pfs-custom__image-banner").parent().find(".boost-pfs-filter-product-item")[0]).find('.boost-pfs-filter-product-item-main-image').height();
                $(this).find('img').css("max-height", productImageHeight);
            });
            
            
            // Adds resize listener that hides banner images below 1024px
            $(window).resize(function () {
                if ($(window).width() < 1024) {
                    $(".boost-pfs-custom__image-banner").hide();
                } else {
                    $(".boost-pfs-custom__image-banner").show();
                }

                // Update the banner image max-height on resize to match product image height
                $(".boost-pfs-custom__image-banner").each(function () {
                    let productImageHeight = $($(".boost-pfs-custom__image-banner").parent().find(".boost-pfs-filter-product-item")[0]).find('.boost-pfs-filter-product-item-main-image').height();
                    $(this).find('img').css("max-height", productImageHeight);
                });
            });
        

            // On load, render availables sizes for each product
            $(".boost-pfs-filter-product-item").each(function () {
                let wrapper = $(this).find(".boost-pfs-filter-product-item__sizes");
                let sizes = $(this).find(".boost-pfs-filter-product-item__sizes").data("available-sizes");
                if (typeof sizes !== undefined && sizes !== "") {
                    sizes = sizes.split(',');

                    // Sort empty strings from the array
                    sizes = sizes.filter(function (el) {
                        return el != "";
                    });

                    // If there are no sizes, hide the wrapper
                    if (sizes.length === 0) {
                        wrapper.hide();
                    }

                    // Loop through the sizes and append them to the wrapper
                    for (let i = 0; i < sizes.length; i++) {
                        if (sizes[i] === "") continue;

                        const soldoutClass = sizes[i].includes("s") ? "sold-out" : "";
                        const size = sizes[i].replace("s", "");
                        
                        wrapper.append(`<span class="${soldoutClass}">${size}</span>`);

                        // render size with comma if it's not the last one
                        // if (i !== sizes.length - 1) {
                        //     wrapper.append(`<span class="${soldoutClass}">${size}</span>`);
                        // } else {
                        //     wrapper.append(`<span class="${soldoutClass}>${size}</span>`);
                        // }
                    }
                }
            });

        // }, 1000); // compensate for boost loadtime
        

        // // On hover display available sizes instead of price
        // $(".boost-pfs-filter-product-item").hover(function () {
        //     // Checks if .boost-pfs-filter-product-item__sizes has any children
        //     if ($(this).find(".boost-pfs-filter-product-item__sizes").children().length !== 0) {
        //         $(this).find(".boost-pfs-filter-product-item-price").hide();
        //         $(this).find(".boost-pfs-filter-product-item__sizes").show();
        //     }

        //     // On exit, hide available sizes and show price again
        //     }, function () {
        //         if ($(this).find(".boost-pfs-filter-product-item__sizes").children().length !== 0) {
        //             $(this).find(".boost-pfs-filter-product-item-price").show();
        //             $(this).find(".boost-pfs-filter-product-item__sizes").hide();
        //         }
        // });

        /**
         * Replace the default Boost PFS filter icon with a custom one
         */
        const customSVGArrow = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z" clip-rule="evenodd" /></svg>`;
        // $(".boost-pfs-filter-tree-desktop-button-icon svg").remove();

        // $(".boost-pfs-filter-tree-desktop-button-icon").append(customSVGArrow);
        $("boost-pfs-filter-toolbar-top-desktop-inner boost-pfs-filter-top-sorting-wrapper").append(customSVGArrow);
        $(".boost-pfs-filter-toolbar-top-mobile-inner .boost-pfs-filter-top-sorting-wrapper").append(customSVGArrow);


        /* Trigger Boost-pfs-offcanvas to close */
        $('.boost-pfs-filter__offcanvas-close').click( () => {
            $('.boost-pfs-filter-tree-desktop-button button').click();
        });
    }, 1000); // Compensate for boost loadtime
});
